<template>

  <div>
    <div v-if="mostrarForm">
      <area-sucursal-form-component :original="datosForm" @_cancelarEditar="cancelarEditar"
      :optionsCliente="optionsCliente"></area-sucursal-form-component>
    </div>
    <div v-else>
      <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
        <div
            class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
          <div class="mb-4 mb-xl-0">
            <div class="fs-3 fw-bold text-white">Áreas de Sucursal</div>
            <div class="text-white-50">En ésta sección podrás administrar las areas de las sucursales, así como sus turnos</div>
          </div>
          <div class="mb-4 mb-xl-0">
            <div class="row">
              <div class="col">
                <button type="button" class="btn btn-success btn-sm"
                        @click="editar(null)">
                  <FontAwesomeIcon :icon="faPlus()"/>
                  Agregar Área Sucursal
                </button>
              </div>
            </div>
          </div>
        </div>
      </aside>

      <div class="container px-lg-3 px-xl-2 px-xxl-2 mt-2">
        <div class="row ">

          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">Cliente</span>
              <input v-model="filtros.nombre_cliente"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre del cliente"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.nombre_cliente=null"
                      v-if="filtros.nombre_cliente!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre del cliente"/>
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">Sucursal</span>
              <input v-model="filtros.nombre_sucursal"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre de la sucursal"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.nombre_sucursal=null"
                      v-if="filtros.nombre_sucursal!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre de la sucursal"/>
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">Área</span>
              <input v-model="filtros.nombre_area_sucursal"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre del área"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.nombre_area_sucursal=null"
                      v-if="filtros.nombre_area_sucursal!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre del área"/>
              </button>
            </div>
          </div>
          <div class="col-12">
            <button type="button" class="btn btn-success" style="float: right;" @click="obtener()">
              <FontAwesomeIcon :icon="faSearch()"/>
              Buscar
            </button>
          </div>

        </div>
      </div>

      <div class="container">
        <div class="row m-4">
          <div class="col" align="right">

          </div>
        </div>
        <div class="row">
          <div class="table-responsive" style="height: 200px">
            <table class="table table-striped table-light table-border">
              <thead>
              <tr>
                <th width="20%" class="header" scope="col">ID</th>
                <th width="20%" class="header" scope="col">Cliente</th>
                <th width="20%" class="header" scope="col">Sucursal</th>
                <th width="20%" class="header" scope="col">Área</th>
                <th width="20%" class="header" scope="col">Acciones</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in datos_tabla" v-bind:key="item.id">
                <th scope="row">{{ item.id }}</th>
                <th scope="row">{{ item.nombre_cliente }}</th>
                <th scope="row">{{ item.nombre_sucursal }}</th>
                <th scope="row">{{ item.nombre_area_sucursal }}</th>
                <th scope="row">
                  <button v-if="item.registroActivo" class="btn btn-danger m-1"
                          @click="activarDesactivar(item.id)" title="Desactivar">
                    <FontAwesomeIcon :icon="faDesActivar()"/>
                  </button>
                  <button v-else class="btn btn-secondary m-1" @click="activarDesactivar(item.id)" title="Re-Activar">
                    <FontAwesomeIcon :icon="faActivar()"/>
                  </button>
                  <button class="btn btn-warning m-1" @click="editar(item)" title="Editar">
                    <FontAwesomeIcon :icon="faEditar()"/>
                  </button>
                </th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import {inject} from "vue";
import {faClose, faEdit, faPlus, faRedo, faSearch, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {ClienteService} from "@/services/ClienteService";
import {AreaSucursalService} from "@/services/AreaSucursalService";
import AreaSucursalFormComponent from "@/views/Area-SucursalForm-Component.vue";

export default {
  name: 'Area-Sucursal-Component',
  components: {
    AreaSucursalFormComponent,
    FontAwesomeIcon
  },
  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_ClienteService: new ClienteService(inject('$axios')),
      srv_AreaSucursalService: new AreaSucursalService(inject('$axios'))
    }
  },
  props: {},
  data() {
    return {
      filtros: {
        nombre_area_sucursal: null,
        nombre_sucursal: null,
        nombre_cliente: null
      },
      datos_tabla: [],
      id: null,

      mostrarForm: false,
      datosForm: null,
      optionsCliente: [],
    }
  },
  async mounted() {
    await this.obtener();
    await this.obtenerClientes();
  },
  methods: {
    faPlus() {
      return faPlus;
    },
    faSearch() {
      return faSearch;
    },
    faClose() {
      return faClose;
    },
    faActivar() {
      return faRedo;
    },
    faDesActivar() {
      return faTrash;
    },
    faEditar() {
      return faEdit;
    },
    async obtener() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      this.datos_tabla = [];
      await this.srv_AreaSucursalService.obtener(this.filtros).then((response) => {
        this.datos_tabla = response;
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    async activarDesactivar(num) {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });
      await this.srv_AreaSucursalService.activarInactivar(num).then(() => {
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => {
        load.hide();
        this.obtener();
      });
    },
    editar(data) {
      this.mostrarForm = true;
      this.datosForm = data;
    },
    cancelarEditar() {
      this.mostrarForm = false;
      this.datosForm = null;
      this.obtener();
    },

    async obtenerClientes() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      this.optionsCliente = [];
      await this.srv_ClienteService.obtener({registro_activo: true}).then((response) => {
        this.optionsCliente = response;
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
  }
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
}
</style>